import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Routes, Route } from 'react-router-dom';
import Astronauts from './pages/Astronauts/Astronauts';
import Experimental from './pages/Experimental/Experimental';
import Home from './pages/Home/Home';
import BirthdayPicture from './pages/Nasa/BirthdayPicture';
import News from './pages/News/News';
var AppRouting = function () { return (_jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Home, {}) }), _jsx(Route, { path: "/news", element: _jsx(News, {}) }), _jsx(Route, { path: "/astronauts", element: _jsx(Astronauts, {}) }), _jsx(Route, { path: "/experimental", element: _jsx(Experimental, {}) }), _jsx(Route, { path: "/birthday", element: _jsx(BirthdayPicture, {}) })] })); };
export default AppRouting;
